module.exports = __webpack_public_path__ + "static/media/2.ae767293.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/有機椰子糖奶酥醬/2.JPG
// module id = 935
// module chunks = 0